import { PendingCounts } from '../domain/entities/PendingCounts';
import { ReportData } from '../domain/entities/ReportData';
import { ReportsInsightsData } from '../domain/entities/ReportsInsightsData';
import { IDashboardRepository } from '../ports/outbound/IDashboardRepository';

export class DashboardUseCases {
  constructor(private repo: IDashboardRepository) {}

  async fetchPendingCounts(): Promise<PendingCounts> {
    return this.repo.fetchPendingCounts();
  }

  async fetchReportData(): Promise<ReportData[]> {
    return this.repo.fetchReportData();
  }

  async fetchReportsInsights(): Promise<ReportsInsightsData> {
    return this.repo.fetchReportsInsights();
  }
}
